import { formatPriceCop } from "../price-format";
import type { Product } from "./types";

export type SpecRow = { label: string; value: string };

export function getProductSpecRows(product: Product): SpecRow[] {
  switch (product.category) {
    case "mug":
      return [
        { label: "Material", value: product.specs.material },
        { label: "Capacidad", value: `${product.specs.capacityOz} oz` },
        {
          label: "Lavado",
          value: product.specs.dishwasherSafe
            ? "Apto lavavajillas (recomendado mano para conservar el grabado)"
            : "Solo lavado a mano",
        },
      ];
    case "mousepad":
      return [
        { label: "Tamaño", value: `${product.specs.widthCm} × ${product.specs.heightCm} cm` },
        { label: "Grosor", value: `${product.specs.thicknessMm} mm` },
        { label: "Borde cosido", value: product.specs.stitchedEdge ? "Sí" : "No" },
        { label: "Base", value: product.specs.baseMaterial },
      ];
    case "coaster":
      return [
        { label: "Material", value: product.specs.material },
        { label: "Set", value: `${product.specs.setQuantity} unidades` },
        { label: "Diámetro", value: `${product.specs.diameterCm} cm` },
      ];
    case "thermos":
      return [
        { label: "Capacidad", value: `${product.specs.capacityMl} ml` },
        { label: "Cuerpo", value: product.specs.bodyMaterial },
        { label: "Calor (aprox.)", value: `Hasta ${product.specs.keepsHotHours} h` },
      ];
    case "poster_aluminum":
      return [
        { label: "Medida", value: `${product.specs.widthCm} × ${product.specs.heightCm} cm` },
        { label: "Acabado", value: product.specs.finish },
        { label: "Soporte", value: "Chapa aluminio sublimada" },
      ];
    case "puzzle":
      return [
        { label: "Piezas", value: String(product.specs.pieceCount) },
        { label: "Tamaño armado", value: product.specs.finishedSizeCm },
        { label: "Material", value: product.specs.material },
      ];
    case "keychain":
      return [
        { label: "Material", value: product.specs.material },
        { label: "Doble cara", value: product.specs.doubleSided ? "Sí" : "No" },
        { label: "Herraje", value: product.specs.hardware },
      ];
    case "tee":
      return [
        { label: "Tela", value: product.specs.fabric },
        { label: "Corte", value: product.specs.fit },
        { label: "Tallas", value: product.specs.availableSizes.join(", ") },
        { label: "Estampa", value: product.specs.printType },
      ];
    case "hoodie":
      return [
        { label: "Tela", value: product.specs.fabric },
        { label: "Corte", value: product.specs.fit },
        { label: "Tallas", value: product.specs.availableSizes.join(", ") },
        { label: "Estampa", value: product.specs.printType },
        { label: "Bolsillo", value: product.specs.hasPouch ? "Canguro" : "No aplica" },
      ];
    case "mystery_box":
      return [
        { label: "Nivel", value: product.specs.tier },
        { label: "Piezas mín.", value: String(product.specs.minItems) },
        {
          label: "Valor referencia",
          value: `Hasta ${formatPriceCop(product.specs.maxRetailValueCop)}`,
        },
        {
          label: "Print exclusivo",
          value: product.specs.includesExclusivePrint ? "Incluido" : "No incluido",
        },
      ];
  }
}

export function categoryLabelEs(category: Product["category"]): string {
  const map: Record<Product["category"], string> = {
    mug: "Tazas",
    mousepad: "Mouse pads",
    coaster: "Portavasos",
    thermos: "Termos y caramañolas",
    poster_aluminum: "Posters aluminio",
    puzzle: "Rompecabezas",
    keychain: "Llaveros",
    tee: "Camisetas",
    hoodie: "Buzos",
    mystery_box: "Mystery box",
  };
  return map[category];
}
